angular.module("WixBI", [ "wix.common.bi", "WixBIUtils" ]);

var WixBIUtils;

(function(WixBIUtils) {
    var BIUtils = function() {
        function BIUtils() {
            this.mergeProperties = function mergeProperties(source, params) {
                var result = angular.copy(source);
                for (var prop in params) {
                    if (typeof params[prop] === "object" && params[prop] !== null) {
                        result[prop] = mergeProperties(result[prop] || {}, params[prop]);
                    } else {
                        result[prop] = params[prop];
                    }
                }
                return result;
            };
        }
        return BIUtils;
    }();
    WixBIUtils.BIUtils = BIUtils;
})(WixBIUtils || (WixBIUtils = {}));

angular.module("WixBIUtils", []).provider("wixBiUtils", [ function() {
    this.setConfig = function() {};
    this.$get = [ function() {
        return new WixBIUtils.BIUtils();
    } ];
} ]);

var WixBI;

(function(WixBI) {
    var WixBIAdapter = function() {
        WixBIAdapter.$inject = [ "biLogger", "BIEventsList", "biUtils", "$q" ];
        function WixBIAdapter(biLogger, BIEventsList, biUtils, $q) {
            this.biLogger = biLogger;
            this.BIEventsList = BIEventsList;
            this.biUtils = biUtils;
            this.$q = $q;
        }
        WixBIAdapter.prototype.trackOnBILogger = function(eventData) {
            var deferred = this.$q.defer();
            for (var key in eventData) {
                var value = eventData[key];
                if (key.match(/.+_long$/gi) && value !== null) {
                    eventData[key] = Math.floor(value * 1e5);
                }
            }
            if (typeof eventData.evid !== "undefined") {
                this.biLogger.log(eventData, function() {
                    deferred.resolve();
                });
            } else {
                deferred.reject();
            }
            return deferred.promise;
        };
        WixBIAdapter.prototype.sendBIEvent = function(event, extraParams) {
            var wixBiEventData = {};
            if (!event) {
                throw new Error("sendBIEvent was called without an event");
            }
            var eventData = angular.isObject(event) ? angular.copy(event) : angular.copy(this.BIEventsList[event]);
            if (!eventData) {
                throw 'Event "' + event + '" is not defined in the BIEventsList constant';
            }
            if (extraParams) {
                eventData = this.biUtils.mergeProperties(eventData, extraParams);
            }
            if (eventData.wixBi) {
                wixBiEventData = eventData.wixBi;
                delete eventData.wixBi;
            }
            var biLoggerPromise = this.trackOnBILogger(this.biUtils.mergeProperties(eventData, wixBiEventData));
            return this.$q.all([ biLoggerPromise ]);
        };
        WixBIAdapter.prototype.sendErrorEvent = function(action, errorCode, httpCode) {
            var deferred = this.$q.defer();
            var eventData = {
                errc: errorCode,
                sev: 30,
                p1: action
            };
            if (httpCode) {
                eventData.httpc = httpCode;
            }
            this.biLogger.error(eventData, function() {
                deferred.resolve();
            });
            return deferred.promise;
        };
        return WixBIAdapter;
    }();
    WixBI.WixBIAdapter = WixBIAdapter;
})(WixBI || (WixBI = {}));

angular.module("WixBI").provider("wixBIAdapter", [ "biLoggerProvider", "wixBiUtilsProvider", function(biLoggerProvider, wixBiUtilsProvider) {
    this.setConfig = function(wixBIAdapterConfig) {
        if (wixBIAdapterConfig.globalBIConfig && wixBIAdapterConfig.globalBIConfig.defaultEventArgs) {
            if (!wixBIAdapterConfig.biLoggerConfig.defaultEventArgs) wixBIAdapterConfig.biLoggerConfig.defaultEventArgs = {};
            angular.extend(wixBIAdapterConfig.biLoggerConfig.defaultEventArgs, wixBIAdapterConfig.globalBIConfig.defaultEventArgs);
        }
        biLoggerProvider.setConfig(wixBIAdapterConfig.biLoggerConfig);
    };
    this.$get = [ "$q", "biLogger", "BIEventsList", "wixBiUtils", function($q, biLogger, BIEventsList, wixBiUtils) {
        return new WixBI.WixBIAdapter(biLogger, BIEventsList, wixBiUtils, $q);
    } ];
} ]);

/*** EXPORTS FROM exports-loader ***/
if (!window["WixBIUtils"]) {window["WixBIUtils"] = {}};for (prop in WixBIUtils) {if (WixBIUtils.hasOwnProperty(prop)) {window["WixBIUtils"][prop] = WixBIUtils[prop]}};
if (!window["WixBI"]) {window["WixBI"] = {}};for (prop in WixBI) {if (WixBI.hasOwnProperty(prop)) {window["WixBI"][prop] = WixBI[prop]}};